<template>
    <div>
        <div style="padding:16px">
            <div class="title">
                填写查询信息
            </div>
            <div class="display_flex searchRow">
                <van-search placeholder="输入手机号搜索" v-model="phone" type="number" maxlength="11" />
            </div>
            <div class="display_flex searchRow">
                <van-search placeholder="输入身份证号搜索" v-model.trim="idCard" maxlength="18" />
            </div>
            <div class="display_flex searchRow">
                <button class="queryButton" @click="getReport">查询</button>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import ReportApi from './api';
import { login } from '../../util/weiXinUtils';
const reportApi = new ReportApi()
export default {
    data() {
        return {
            phone: '',
            idCard: ''
        }
    },
    created() {
    },
    mounted() {
        login()
    },
    computed: {
    },
    methods: {
        // 校验手机号
        checkPhone() {
            let phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
            if (!this.phone.trim()) {
                Toast('请填写手机号');
                return false
            } else if (this.phone.trim() && !phonereg.test(this.phone.trim())) {
                Toast('手机号格式不对');
                return false
            }
            return true
        },
        // 校验身份证号
        checkIdCard() {
            const idCardReg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
            if (!this.idCard.trim()) {
                Toast('请填写身份证号');
                return false
            } else if (!idCardReg.test(this.idCard.trim())) {
                Toast('身份证号格式不对');
                return false
            }
            return true
        },

        // 根据手机号和身份证号获取报告信息
        async getReport() {
            if (!this.checkPhone() || !this.checkIdCard()) {
                return
            }
            let res = await reportApi.getReport(this.phone.trim(), this.idCard.trim())
            this.clearStore()
            localStorage.setItem('reportData', JSON.stringify(res.data))
            this.$router.push("/report/list")
        },
        // 清除缓存
        clearStore() {
            localStorage.removeItem('reportData')
            localStorage.removeItem('reportList')
            localStorage.removeItem('report')
        },
    },
}
</script>
<style lang="scss" scoped>
.title {
    padding: 17px 0 5px 0;
    font-size: 16px;

    color: #333333;
    line-height: 22px;
    display: flex;
    align-items: center;
}

.title::before {
    content: '';
    width: 2px;
    height: 10px;
    background: #1477FD;
    border-radius: 1px;
    margin-right: 8px;
}

.queryButton {
    width: 100%;
    height: 36px;
    background: #1477FD;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 14px;
    color: #FFFFFF;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.van-search {
    width: 100%;
    height: 36px;
    padding: 0 !important;
}

.searchRow {
    margin-top: 16px;
}

.van-search__content {
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #CCCCCC;

}

.van-field__control {
    font-size: 12px;

    color: #999999;
}

</style>
